const ITEMS = [
  "CENTO (FE)",
  "SAN GIOVANNI IN PERSICETO",
  "SAN PIETRO IN CASALE",
  "FLESSIBILITÀ TOTALE",
  "GUADAGNI REALI",
  "NESSUN ALGORITMO ANONIMO",
  "TEAM LOCALE",
];

export const EditorialTicker = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-ticker"
      className="relative overflow-hidden bg-brand py-3.5 border-y border-brand-deep"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="font-display font-bold text-sm sm:text-base tracking-[0.18em] text-obsidian uppercase whitespace-nowrap px-6 flex items-center gap-6"
              >
                {item}
                <span className="w-1.5 h-1.5 rounded-full bg-obsidian/70 inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
